import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createLogger from 'redux-logger';
import { rootReducer } from './../reducers/_root';

const logger = createLogger({
    collapsed: true,
});

function configureStore(initialState) {
    return createStore(
        rootReducer,
        initialState,
        applyMiddleware(thunkMiddleware, logger),
        window.devToolsExtension ? window.devToolsExtension() : f => f
    );
}

export { configureStore };



// WEBPACK FOOTER //
// ./src/_app/quick_response/store/configureStore.js